import React, { useRef, useState, useEffect } from 'react'
import { CaretDown, CaretUp, DragVertical } from '@carbon/icons-react'

function KnovaText(props) {
  const {
    themeName,
    contWidth,
    contBgColor,
    contBorderWidth,
    contBorderColor,
    contPadding,
    contMargin,
    contBorderRadius,
    cursor,
    isSideMenu,
    alignValue,
    visibility
  } = props
  const {
    text,
    textColor,
    textFontSize,
    textFontWeight,
    textFontFamily,
    textMargin,
    textHeight,
    letterSpacing,
    textAlign,
    textOpacity
  } = props
  const { isIcon, iconName, isDown, iconPosition, iconColor } = props

  function renderIcon() {
    if (iconName === 'dropdown') {
      if (isDown) {
        return <CaretDown color={iconColor} size={isSideMenu ? 10 : 22} />
      } else {
        return <CaretUp color={iconColor} size={isSideMenu ? 10 : 22} />
      }
    } else if (iconName === 'drag') {
      return <DragVertical color={iconColor} size={isSideMenu ? 10 : 22} />
    } else {
      return null
    }
  }

  return (
    <div
      className={
        themeName === 'Theme-5'
          ? 'knova-text-cont theme-5-text-cont'
          : 'knova-text-cont'
      }
      style={{
        width: contWidth ? contWidth : '100%',
        background: contBgColor ? contBgColor : 'transparent',
        borderWidth: contBorderWidth ? contBorderWidth : '0px',
        borderStyle: contBorderWidth ? 'solid' : 'none',
        borderColor: contBorderColor ? contBorderColor : '',
        borderRadius: contBorderRadius ? contBorderRadius : '0px',
        padding: contPadding ? contPadding : '0px',
        margin: contMargin ? contMargin : '0px',
        cursor: cursor ? cursor : 'default',
        alignItems: alignValue ? alignValue : 'start',
        visibility: visibility ? visibility : 'visible'
      }}
    >
      {isIcon && iconPosition === 'start' && renderIcon()}
      <p
        style={{
          width: contWidth ? contWidth : '100%',
          // height:contHeight?contHeight:"unset",
          color: textColor ? textColor : '#000',
          fontSize: textFontSize ? textFontSize : '20px',
          fontWeight: textFontWeight ? textFontWeight : 'normal',
          fontFamily: textFontFamily ? textFontFamily : 'unset',
          margin: textMargin ? textMargin : '0px',
          whiteSpace: 'pre-line',
          lineHeight: textHeight,
          letterSpacing: letterSpacing,
          textAlign: textAlign ? textAlign : 'left',
          opacity: textOpacity ? textOpacity : 1
        }}
      >
        {text}
      </p>
      {isIcon && iconPosition === 'end' && renderIcon()}
    </div>
  )
}
export { KnovaText }
